export const SET_GAME = 'SET_GAME';
export const SET_CARD_VISIBILITY = 'SET_CARD_VISIBILITY';
export const ADD_CARD_TO_PAIR = 'ADD_CARD_TO_PAIR';
export const CHECK_PAIR = 'CHECK_PAIR';
export const RESET_PAIR = 'RESET_PAIR';


// WEBPACK FOOTER //
// ./src/actions/types.js